// Sticky Side filter in listing page - Only runs on collection pages

$(document).ready(function() {
    // Check if we're on a collection page
    if (document.body.classList.contains('template-collection') || 
        window.location.pathname.includes('/collections/') ||
        document.querySelector('.main-collection-grid')) {
        
        var $stickyElement = $('.facets-block-wrapper--vertical,.facets-toggle');
        var $container = $('.main-collection-grid');
        
        // Only proceed if the required elements exist
        if ($stickyElement.length && $container.length) {
            var stickyTop = $stickyElement.offset().top;
            
            $(window).scroll(function() {
                var windowTop = $(window).scrollTop();
                var containerBottom = $container.offset().top + $container.outerHeight();
                var stickyHeight = $stickyElement.outerHeight();
                
                // Check if we should stick
                if (windowTop > stickyTop) {
                    // Check if sticky element would go beyond container
                    if ((windowTop + stickyHeight) > containerBottom) {
                        // Stop sticky - position at container bottom
                        $stickyElement.css({
                            'position': 'absolute',
                            'top': containerBottom - stickyHeight - $container.offset().top,
                            'bottom': 'auto'
                        });
                    } else {
                        // Make sticky
                        $stickyElement.css({
                            'position': 'fixed',
                            'top': '0',
                            'bottom': 'auto'
                        });
                    }
                } else {
                    // Return to normal position
                    $stickyElement.css({
                        'position': 'relative',
                        'top': 'auto',
                        'bottom': 'auto'
                    });
                }
            });
        }
    }
});


// Global promo message handling (runs on all pages)
// Global promo message handling (runs on all pages including product detail pages)
$(document).ready(function() {
    const gridItems = $('.group-block-content > .promo-message-block');
    
    gridItems.each(function(index, item) {
      const $item = $(item);
      // Check if content is empty or only whitespace
      if (!$item.text().trim() && $item.children().length === 0) {
        $item.addClass('empty-item');
      }
    });
  });


// Category slider 
 

// Watch for ss__autocomplete--active class on body and add class to header-menu__inner
$(document).ready(function() {
    var headerMenuInner = $('.header-menu__inner');
    
    if (headerMenuInner.length) {
        // Function to check and update class
        function updateHeaderMenuClass() {
            if ($('body').hasClass('ss__autocomplete--active')) {
                headerMenuInner.addClass('autocomplete-active');
            } else {
                headerMenuInner.removeClass('autocomplete-active');
            }
        }
        
        // Check initially
        updateHeaderMenuClass();
        
        // Watch for class changes on body element using MutationObserver
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    updateHeaderMenuClass();
                }
            });
        });
        
        // Start observing the body element
        observer.observe(document.body, {
            attributes: true,
            attributeFilter: ['class']
        });
    }
});

